import { Fragment } from 'react';

import Views from '../AthleteUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeAthleteEntry/ViewTemplate';

import AthleteUserPurchasesWrite from './AthleteUserPurchasesWrite';
import AthleteUserPurchasesReadOnly from './AthleteUserPurchasesReadOnly';

import useAthleteUserPurchases from './UseAthleteUserPurchases';

const AthleteUserPurchases = () => {
  const { athleteEntryContextState } = useAthleteUserPurchases();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_SUBMIT}>
        {athleteEntryContextState.isReadOnly === false ?
          <AthleteUserPurchasesWrite /> :
          <AthleteUserPurchasesReadOnly />
        }
      </ViewTemplate>
    </Fragment>
  );
};

export default AthleteUserPurchases;